import { createSlice } from "@reduxjs/toolkit";

export const workspacesSlice = createSlice({
  name: 'workspaces',
  initialState: {
    data: null,
    error: null,
    isLoading: false,
  },
  reducers: {
    startWorkspaces: (state) => { state.isLoading = true; },
    setWorkspaces: (state, { payload: { data = null, error = null }}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startWorkspaces, setWorkspaces } = workspacesSlice.actions;
